import { render, staticRenderFns } from "./thinkTanks.vue?vue&type=template&id=cbace7a2&scoped=true"
import script from "./thinkTanks.vue?vue&type=script&lang=js"
export * from "./thinkTanks.vue?vue&type=script&lang=js"
import style0 from "./thinkTanks.vue?vue&type=style&index=0&id=cbace7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbace7a2",
  null
  
)

export default component.exports